/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterAccountTenantSummary {
    getFixupPrototypeFunction() { return MasterAccountTenantSummary.fixupPrototype; }

    static newInstance(model: Partial<MasterAccountTenantSummary>): MasterAccountTenantSummary {
        let obj = Object.assign(new MasterAccountTenantSummary(), model);
        MasterAccountTenantSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterAccountTenantSummary>): MasterAccountTenantSummary {
        if (!model) return null;
        return MasterAccountTenantSummary.newInstance(<MasterAccountTenantSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterAccountTenantSummary) {
        if (!obj) return;

        models.MasterAccountTenantSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterAccountTenantSummary): boolean {
        Object.setPrototypeOf(obj, MasterAccountTenantSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Tenant id
     */
    id: string;

    /**
     * Name of Tenant
     */
    name: string;

    /**
     * Indicates the status of the Tenant
     */
    status: models.TenantStatus;

    /**
     * Is this a default tenant
     */
    is_default: boolean;

}
